import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import * as T from "@radix-ui/react-tooltip";
import { usePortalContainer } from "../portal/index.js";
/* empty css          */
const TooltipRoot = (t0) => {
  const $ = c(13);
  const {
    children,
    align: t1,
    side: t2,
    sideOffset: t3,
    label
  } = t0;
  const align = t1 === void 0 ? "start" : t1;
  const side = t2 === void 0 ? "bottom" : t2;
  const sideOffset = t3 === void 0 ? 5 : t3;
  const container = usePortalContainer();
  let t4;
  if ($[0] !== children) {
    t4 = /* @__PURE__ */ jsx(T.Trigger, { asChild: true, children });
    $[0] = children;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== align || $[3] !== label || $[4] !== side || $[5] !== sideOffset) {
    t5 = /* @__PURE__ */ jsx(T.Content, { className: "graphiql-tooltip", align, side, sideOffset, children: label });
    $[2] = align;
    $[3] = label;
    $[4] = side;
    $[5] = sideOffset;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== container || $[8] !== t5) {
    t6 = /* @__PURE__ */ jsx(T.Portal, { container, children: t5 });
    $[7] = container;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = /* @__PURE__ */ jsxs(T.Root, { children: [
      t4,
      t6
    ] });
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
const Tooltip = Object.assign(TooltipRoot, {
  Provider: T.Provider
});
export {
  Tooltip,
  TooltipRoot
};
//# sourceMappingURL=index.js.map
